import { createSlice } from '@reduxjs/toolkit';
import { getAllBoardDateTable, getAllDateTableTask, updateTask, getTaskMail } from './GetSlice';

const initialState = {
    columnIndex: {
        from: '',
        to: '',
    },
    emailReply: '',
    AddColumnCall: '',
    columns: [],
    columnFormList: [],
    isTableVisible: false,
    isDateVisible: false,
    boardData: [],
    selectedTab: 'GMAIL',
    whatsAppStatus: false,
    emailStatus: false,

    selectedMyDayPlanDate: null,
    selectedReminderDate: null,
    selectedStatusNextStepDate: null,
    note: '',
    notesText: '',
    myDayDate: null,
    deadlineDate: null,
    isMyDayChecked: false,
    isDeadlineChecked: false,

    isLoading: false,
    error: null,

    dateTableData: [],
    boardList: [],

    // Task data management
    taskData: [],
    taskLoading: false,
    taskError: null,
    currentTask: null,
    selecteAssignUser: null,
    whatsappActiveTag: null

};

export const slice = createSlice({
    name: 'redux',
    initialState,
    reducers: {
        // columnIndex: (state, { payload }) => {
        //     state.columnIndex = {
        //         from: payload?.from,
        //         to: payload?.to,
        //     };
        // }, 
        columnIndex: (state, { payload }) => {
            const { from, to } = payload;
            if (from === to || from < 0 || to < 0 || from >= state.columns.length || to >= state.columns.length) {
                return state;
            }

            const newColumns = [...state.columns];
            const [movedColumn] = newColumns.splice(from, 1);
            newColumns.splice(to, 0, movedColumn);

            return {
                ...state,
                columns: newColumns,
                columnIndex: payload
            };
        },
        emailReply: (state) => {
            state.emailReply = Math.random();
        },
        AddColumnCall: (state) => {
            state.AddColumnCall = Math.random();
        },
        addColumnsDetails: (state, action) => {
            state.columns = action.payload;
        },
        addForm: (state, action) => {
            if (!Array.isArray(state.columnFormList)) {
                state.columnFormList = [];
            }
            state.columnFormList.push(action.payload);
        },
        whatsaapActiveTab: (state, action) => {
            state.whatsappActiveTag = action.payload;
        },
        updateForm: (state, action) => {
            const { id, title } = action.payload;
            const form = state.columnFormList.find((f) => f.id === id);
            if (form) {
                form.title = title;
            }
        },
        removeForm: (state, action) => {
            state.columnFormList = state.columnFormList.filter((f) => f.id !== action.payload);
        },
        toggleTable: (state, action) => {
            state.isTableVisible = action.payload;
        },
        toggleDate: (state, action) => {
            state.isDateVisible = action.payload;
        },
        addBoardItem: (state, action) => {
            state.boardData.push(action.payload);
        },
        changeBoradTab: (state, action) => {
            state.selectedTab = action.payload;
        },
        setWhatsAppStatus: (state, action) => {
            state.whatsAppStatus = action.payload;
            if (action.payload) state.emailStatus = false;
        },
        setEmailStatus: (state, action) => {
            state.emailStatus = action.payload;
            if (action.payload) state.whatsAppStatus = false;
        },

        // Task Data Management Actions
        setSelectedMyDayPlanDate: (state, action) => {
            state.selectedMyDayPlanDate = action.payload;
        },
        setSelectedReminderDate: (state, action) => {
            state.selectedReminderDate = action.payload;
        },
        setSelectedStatusNextStepDate: (state, action) => {
            state.selectedStatusNextStepDate = action.payload;
        },
        setNote: (state, action) => {
            state.note = action.payload;
        },
        setNotesText: (state, action) => {
            state.notesText = action.payload;
        },
        setMyDayDate: (state, action) => {
            state.myDayDate = action.payload;
        },
        setDeadlineDate: (state, action) => {
            state.deadlineDate = action.payload;
        },
        setIsMyDayChecked: (state, action) => {
            state.isMyDayChecked = action.payload;
        },
        setIsDeadlineChecked: (state, action) => {
            state.isDeadlineChecked = action.payload;
        },

        setAllAssignUser: (state, action) => {
            state.selecteAssignUser = action.payload;
        },

        // Reset all task data
        resetTaskData: (state) => {
            state.selectedMyDayPlanDate = null;
            state.selectedReminderDate = null;
            state.selectedStatusNextStepDate = null;
            state.note = '';
            state.notesText = '';
            state.myDayDate = null;
            state.deadlineDate = null;
            state.isMyDayChecked = false;
            state.isDeadlineChecked = false;
        },


        getCurrentTask: (state, action) => {
            state.currentTask = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(updateTask.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateTask.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateTask.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getAllDateTableTask.fulfilled, (state, action) => {
                state.dateTableData = action?.payload;
            })
            .addCase(getAllBoardDateTable.fulfilled, (state, action) => {
                state.boardList = action?.payload;
            })

            // Task data management
            .addCase(getTaskMail.pending, (state) => {
                state.taskLoading = true;
                state.taskError = null;
            })
            .addCase(getTaskMail.fulfilled, (state, action) => {
                state.taskLoading = false;
                state.taskData = action.payload;
            })
            .addCase(getTaskMail.rejected, (state, action) => {
                state.taskLoading = false;
                state.taskError = action.payload;
            });
    },
});

export const {
    columnIndex,
    emailReply,
    AddColumnCall,
    addColumnsDetails,
    addForm,
    updateForm,
    removeForm,
    toggleTable,
    addBoardItem,
    changeBoradTab,
    setWhatsAppStatus,
    setEmailStatus,
    setSelectedReminderDate,
    setSelectedMyDayPlanDate,
    setSelectedStatusNextStepDate,
    setNote,
    setNotesText,
    setMyDayDate,
    setDeadlineDate,
    setIsMyDayChecked,
    setIsDeadlineChecked,
    resetTaskData,
    toggleDate,
    getCurrentTask,
    setAllAssignUser,
    whatsaapActiveTab
} = slice.actions;

export default slice.reducer;